import { render, staticRenderFns } from "./FS-KanBan.vue?vue&type=template&id=730d3a4e&scoped=true"
import script from "./FS-KanBan.vue?vue&type=script&lang=js"
export * from "./FS-KanBan.vue?vue&type=script&lang=js"
import style0 from "./FS-KanBan.vue?vue&type=style&index=0&id=730d3a4e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730d3a4e",
  null
  
)

export default component.exports